import {z} from "zod/v4";

export const CustomTimestamp = z.union([
  z.date(),
  z.object({seconds: z.number(), nanoseconds: z.number()}).transform((ts) => {
    return new Date(ts.seconds * 1000 + ts.nanoseconds / 1_000_000);
  }),
  z.object({_seconds: z.number(), _nanoseconds: z.number()}).transform((ts) => {
    return new Date(ts._seconds * 1000 + ts._nanoseconds / 1_000_000);
  }),
  z.string().transform((val) => new Date(val)), // Directly transform string to Date
]);
export const DocumentSchema = z.strictObject({
  id: z.string(),
});
export const UserEntitySchema = z.strictObject({
  name: z.string(),
  color: z.string(),
});
export const UserDocSchema = z.object({
  ...UserEntitySchema.shape,
  ...DocumentSchema.shape,
});
export const PointEntitySchema = z.strictObject({
  x: z.number(),
  y: z.number(),
});

export const ShardCollectedSchema = z.strictObject({
  shardId: z.number(),
  steps: z.number(),
});

export const ReplayEntitySchema = z.strictObject({
  completed: z.boolean(),
  totalSteps: z.number(),
  died: z.boolean(),
  step: z.number(),
  currentPosition: PointEntitySchema,
  previousPosition: PointEntitySchema,
  currentVelocity: PointEntitySchema,
  actions: z.array(z.boolean()),
  shards: z.array(ShardCollectedSchema),
  timestamp: CustomTimestamp,
});

export const UserReplayEntitySchema = z.strictObject({
  userId: z.string(),
  replay: ReplayEntitySchema,
});

export const SettingsEntitySchema = z.strictObject({
  showFps: z.boolean(),
  liveReplays: z.boolean(),
  showPlayerNames: z.boolean(),
  showTrails: z.boolean(),
  showPersonalBestGhost: z.boolean(),
  musicVolume: z.number().min(0).max(1),
  soundVolume: z.number().min(0).max(1),
  enableLogViewer: z.boolean(),
});
export const SettingsDocSchema = z.object({
  ...SettingsEntitySchema.shape,
  ...DocumentSchema.shape,
});
export const GameVersionEntitySchema = z.strictObject({
  version: z.string(),
});
export const GameVersionDocSchema = z.object({
  ...GameVersionEntitySchema.shape,
  ...DocumentSchema.shape,
});
export type UserDoc = z.infer<typeof UserDocSchema>;
export type PointEntity = z.infer<typeof PointEntitySchema>;
export type ShardCollected = z.infer<typeof ShardCollectedSchema>;
export type UserReplayEntity = z.infer<typeof UserReplayEntitySchema>;
export type ReplayEntity = z.infer<typeof ReplayEntitySchema>;
export type SettingsEntity = z.infer<typeof SettingsEntitySchema>;
export type SettingsDoc = z.infer<typeof SettingsDocSchema>;
export type GameVersionDoc = z.infer<typeof GameVersionDocSchema>;
